import { render } from "./SuccessInstall.vue?vue&type=template&id=3f0d3e88&ts=true"
import script from "./SuccessInstall.vue?vue&type=script&lang=ts"
export * from "./SuccessInstall.vue?vue&type=script&lang=ts"

import "./SuccessInstall.vue?vue&type=style&index=0&id=3f0d3e88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__